/**
 * WB4 — Role composition landing routes in command palette (not footer).
 * SSOT: workbench-role-composition-registry landingRoute + role-gated visibility.
 */

import type { CommandEntry } from './command-registry';
import { ROLE_COMPOSITION_REGISTRY } from './workbench-role-composition-registry';
import type { WorkbenchRole } from './workbench-role-cockpit-config';
import { ROLES, type UserRole } from '@shared/types/roles';

const WORKBENCH_ROLE_PALETTE_ROLES: Partial<Record<WorkbenchRole, readonly UserRole[]>> = {
  sales: [ROLES.SALES, ROLES.EXTERNAL],
  warehouse: [ROLES.OPERATIONS_MANAGER],
  finance: [ROLES.ACCOUNTING],
  admin: [ROLES.HR_ADMIN],
  owner: [ROLES.OWNER],
};

const ROLE_PALETTE_LABELS: Partial<Record<WorkbenchRole, string>> = {
  sales: '영업 큐 보드',
  warehouse: '창고 운영 보드',
  finance: '재무 예외 큐',
  admin: '권한 감사 보드',
  owner: '경영진 코크핏',
};

export function buildRoleCompositionPaletteCommandEntries(): CommandEntry[] {
  const entries: CommandEntry[] = [];

  for (const [role, spec] of Object.entries(ROLE_COMPOSITION_REGISTRY) as [
    WorkbenchRole,
    (typeof ROLE_COMPOSITION_REGISTRY)[WorkbenchRole],
  ][]) {
    if (!spec?.landingRoute || spec.pageMode !== 'full_page') {
      continue;
    }

    const roles = WORKBENCH_ROLE_PALETTE_ROLES[role];
    if (!roles?.length) {
      continue;
    }

    entries.push({
      id: `nav-workspace-role-${role}`,
      label: ROLE_PALETTE_LABELS[role] ?? spec.landingRoute,
      keywords: ['workspace', 'role', role, '보드', '큐'],
      kind: 'navigate',
      route: spec.landingRoute,
      paletteGroup: 'go',
      planes: ['business'],
      roles: [...roles],
      priority: 76,
      businessDomains: ['task_execution'],
    });
  }

  return entries;
}
